export const BEACON_LINK = "https://www.beaconhomeless.org"
export const JA_LINK = "https://www.januaryadvisors.com/"
export const CTR_ISSUE_FORM = "https://docs.google.com/forms/d/e/1FAIpQLScZrmp2h_dmB9vJYTMmn010qtUR9mbl6rci0s74k1fIbJVNlQ/viewform"
export const HCDC_LINK = "https://www.hcdistrictclerk.com/Common/Default.aspx"
export const TAJF_LINK = "https://www.teajf.org/"